import { Component, inject, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { AddProductComponent } from "../add-product/add-product.component";
@Component({
  selector: "app-product-list",
  imports: [CommonModule, SharedModule],
  templateUrl: "./product-list.component.html",
  styleUrl: "./product-list.component.scss",
})
export class ProductListComponent implements OnInit, OnDestroy {
  private masterService = inject(MasterService);
  private dialog = inject(MatDialog);
  private imageScrollInterval: any;

  ngOnInit(): void {
    this.getProductList();
  }

  ngOnDestroy(): void {
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
    }
  }

  // ngAfterViewInit() {
  //   this.paginator.page.pipe(tap(() => this.getProductList(this.paginator.pageIndex + 1, this.paginator.pageSize))).subscribe();
  //   this.getProductList(this.paginator.pageIndex + 1, this.paginator.pageSize);
  // }

  //#region variables
  productList: any;
  filteredProductList: any;
  dataSource = new MatTableDataSource<any>();
  length = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  readonly SVG_ICONS = SVG_ICONS;
  searchQuery = "";
  //#endregion

  getProductList() {
    // const sort = `ORDER BY ${sortColumn} ${sortDirection}`;
    this.masterService.getProductList(1, 100, "").subscribe((res: any) => {
      this.productList = res.data.map((product: any) => ({
        ...product,
        currentImageIndex: 0,
      }));
      this.filteredProductList = this.productList;
      this.startImageScroll();
    });
  }

  startImageScroll() {
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
    }
    this.imageScrollInterval = setInterval(() => {
      if (this.filteredProductList) {
        this.filteredProductList.forEach((product: any) => {
          if (product.Documents && product.Documents.length > 1) {
            product.currentImageIndex = (product.currentImageIndex + 1) % product.Documents.length;
          }
        });
      }
    }, 2000);
  }

  onCreateProduct() {
    const dialogRef = this.dialog.open(AddProductComponent, {
      width: window.innerWidth > 768 ? "60%" : "70%",
      maxWidth: "70vw",
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getProductList();
    });
  }

  onEditProduct(id: number) {
    this.dialog.open(AddProductComponent, {
      width: window.innerWidth > 768 ? "60%" : "70%",
      maxWidth: "70vw",
      data: { productId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getProductList();
    });
  }

  applyFilter(filterValue: string) {
    this.filteredProductList = this.productList.filter((product: any) => product.ProductName.toLowerCase().includes(filterValue.toLowerCase()));
  }
}
